import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useScreenSize, useCustomScreen } from "../Utils";

const ProjectTypes = [
  {
    id: 1,
    name: "Residential",
    image: "/images/Residential.png",
  },
  {
    id: 2,
    name: "Commercial",
    image: "/images/Commercial.png",
  },
  {
    id: 3,
    name: "Multi-family",
    image: "/images/MultiFamily.png",
  },
  {
    id: 4,
    name: "Blueprints",
    image: "/images/Blueprints.png",
  },
];

export default function ProjectSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();

  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();

  return (
    <section id="reports-sec" className="reports-sec">
      <div className="container position-relative">
        <header className="section-header my-5">
          <h1
            style={{
              color: "#ffffff",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.7rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen
                ? "2.4rem"
                : isMediumScreen
                ? "2.4rem"
                : "2rem",
            }}
          >
            No matter your project, we can help
          </h1>
        </header>
        <div className="row mt-3">
          {ProjectTypes.map((item) => {
            const { id, name, image } = item;
            return (
              <div
                className={`col-xl-3 col-lg-${
                  isLargeScreen && isLandscape1024 ? "3" : ""
                } col-md-6 mt-3 align-items-stretch`}
                key={id}
              >
                <div className="icon-box">
                  <div className="icon">
                    <i>
                      <img src={image} alt={name} />
                    </i>
                  </div>
                  <h4
                    style={{
                      fontSize: is4kScreen
                        ? "3rem"
                        : isXxlScreen
                        ? "1.7rem"
                        : isXlScreen
                        ? "1.7rem"
                        : isIpadProPortrait
                        ? "1.9rem"
                        : isLargeScreen
                        ? "1.6rem"
                        : "26px",
                      fontWeight: "bold",
                    }}
                  >
                    {name}
                  </h4>
                </div>
              </div>
            );
          })}
        </div>
        <header className="section-header mb-5">
          <p
            className="my-3 pt-3 text-white"
            style={{
              fontSize: is4kScreen
                ? "5rem"
                : isXxlScreen
                ? "2.2rem"
                : isXlScreen
                ? "2.2rem"
                : isIpadProPortrait
                ? "2.2rem"
                : isLargeScreen
                ? "2rem"
                : isMediumScreen
                ? "1.8rem"
                : "26px",
            }}
          >
            <Link
              to="/contact-us"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              Contact us
            </Link>{" "}
            with any questions regarding your project
          </p>
        </header>
      </div>
    </section>
  );
}
